import { NIA_TRANSPORT } from "../data/site";
import { MobilityMapSvg } from "./MobilityMapSvg";

export function MobilityHubMap({ active, onSelect }) {
  const current = NIA_TRANSPORT.find((m) => m.id === active);

  return (
    <div className="border border-[#D4AF37]/15 bg-[#0A0A0A] rounded-[2px] overflow-hidden" data-testid="mobility-hub-map">
      <div className="flex flex-wrap items-center gap-2 p-4 border-b border-[#D4AF37]/10" data-testid="mobility-map-legend">
        {NIA_TRANSPORT.map((m) => (
          <button
            key={m.id}
            type="button"
            onClick={() => onSelect(m.id)}
            data-testid={`mobility-legend-${m.id}`}
            aria-pressed={active === m.id}
            className={`px-3 py-1.5 text-[10px] uppercase tracking-[0.18em] rounded-full border transition-colors ${
              active === m.id ? "bg-gradient-to-r from-[#C5A059] to-[#D4AF37] text-black border-transparent" : "border-[#D4AF37]/20 text-[#71717A] hover:text-[#F3E5AB]"
            }`}
          >
            {m.mode}
          </button>
        ))}
        <span className="ml-auto text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]" data-testid="mobility-map-active-label">
          {current.mode} &middot; {current.stat}
        </span>
      </div>

      <MobilityMapSvg active={active} />
    </div>
  );
}
